import { Breadcrumbs, Typography } from '@mui/material';
import { Link } from '@tanstack/react-router';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';

export interface ProjectBreadcrumbProps {
  projectId: string;
  projectName: string;
  currentPage: string;
  currentDetail?: string;
}

export function ProjectBreadcrumb({
  projectId,
  projectName,
  currentPage,
  currentDetail,
}: ProjectBreadcrumbProps) {
  const label = currentDetail
    ? `${currentPage} (${currentDetail})`
    : currentPage;

  const linkStyle = {
    color: 'inherit',
    textDecoration: 'none',
    '&:hover': { textDecoration: 'underline' },
  } as const;

  return (
    <Breadcrumbs
      separator={<NavigateNextIcon fontSize="small" />}
      sx={{ mb: 2 }}
    >
      <Typography
        variant="body2"
        component={Link}
        to="/projects"
        sx={linkStyle}
      >
        Projects
      </Typography>
      <Typography
        variant="body2"
        component={Link}
        to={`/projects/${projectId}`}
        sx={linkStyle}
      >
        {projectName}
      </Typography>
      <Typography variant="body2" color="text.primary">
        {label}
      </Typography>
    </Breadcrumbs>
  );
}
